import React from 'react';

import InputText from '@/src/components/common/Elements/InputText/InputText';

import InputWithLabelLayout from '../InputWithLabelLayout';

const inputName = 'compose-email-subject';

const SubjectInput = ({ subject, onInput }) => {
  return (
    <InputWithLabelLayout label="Subject">
      <InputText
        onInput={onInput}
        value={subject}
        placeholder={'Type'}
        name={inputName}
        autoComplete={'new-text'}
      />
    </InputWithLabelLayout>
  );
};

export default SubjectInput;
